import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  ProgressBar,
  Button,
  Alert
} from "react-bootstrap";
import { Link } from 'react-router-dom';
import axiosInstance from '../../services/AxiosInstance';

const Modules = () => {
  const navigate = useNavigate();
  const [modulesList, setModulesList] = useState([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [orgModuleList, setOrgModuleList] = useState([])

  useEffect(() => {
    const fetchModules = async () => {
      let token = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
      const sanitizedToken = token.replace(/^"(.*)"$/, '$1');

      try {
        const response = await axiosInstance.get(`/modules/list`);

        const data = response.data;
        setModulesList(data);
        setOrgModuleList(data)
      } catch (error) {
        console.error('Error fetching modules:', error);
      }
    };

    fetchModules();
  }, []);

  useEffect(() => {
    if (searchText === '') {
      // If empty, reset to full list
      setModulesList(orgModuleList);
    } else {
      // Always filter from original tasklist
      const filtered = modulesList.filter(item =>
        item.ModuleName.toLowerCase().includes(searchText.toLowerCase())
      );
      setModulesList(filtered);
    }
  }, [searchText, modulesList]);
  const toggleModule = (id) => {
    const numericId = Number(id);
    setSelectedModules((prev) =>
      prev.includes(numericId) ? prev.filter((m) => m !== numericId) : [...prev, numericId]
    );
    console.log(selectedModules)
  };

  const totalPrice = selectedModules.reduce((total, id) => {
    const mod = modulesList.find((m) => m.ModuleId === id);
    return total + (parseFloat(mod?.Price) || 0);
  }, 0);
  console.log(totalPrice)
  const handleSubmit = () => {
    if (!selectedModules || selectedModules.length === 0) {
      alert('Please select at least one module before continuing.');
      return;
    }

    const selected = modulesList.filter((m) => selectedModules.includes(m.ModuleId));


    localStorage.setItem('selectedModules', JSON.stringify(selected));
    localStorage.setItem('selectedModulesTotalPrice', parseFloat(totalPrice).toFixed(2));

    // Navigate to next page
    navigate('/subscription');
  };
  const formatUSD = (amount) => {
    const n = parseFloat(amount);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(Number.isFinite(n) ? n : 0);
  };

  return (
    <>
      <div className="input-group contacts-search mb-4">
        <input type="text" className="form-control" placeholder="Search here..." value={searchText}
          onChange={(e) => setSearchText(e.target.value)} />
        <span className="input-group-text"><Link to={"#"}><i className="flaticon-381-search-2" ></i></Link></span>
      </div>
      <Row xs={1} sm={2} md={3} className="g-3">
        {modulesList && modulesList.length > 0 ? (
          modulesList.map((item, index) => (
            <Col key={index}>
              <Card>
                <Card.Header className="border-0 pb-0">
                  <Card.Title>{item.ModuleName}</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Card.Text>{item.Description}</Card.Text>
                </Card.Body>
                <Card.Footer className="border-0 pt-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <span className="text-muted">Price:</span>{' '}
                      <span className="fw-bold fs-5 text-success">{formatUSD(item.Price)}</span>
                    </div>
                    <Button variant="success">Subscribe</Button>
                  </div>
                </Card.Footer>

              </Card>
            </Col>
          ))
        ) : (
          <div className="text-center w-100">
            <p className="text-muted fs-5">No modules available to display.</p>
          </div>
        )}
      </Row>
    </>
  );
};
export default Modules;